let documentScrollPosition = 0

export default {
  data () {
    return {
      scrollPosition: 0,
      bodyPadding: 0
    }
  },
  methods: {
    disableBodyScroll ($el = null) {
      if (this.$device?.isIos) {
        const scrollBarGap = window.innerWidth - document.documentElement.clientWidth

        if (scrollBarGap > 0) {
          this.bodyPadding = document.body.style.paddingRight
          document.body.style.paddingRight = `${scrollBarGap}px`
        }

        this.scrollPosition = window.pageYOffset
        document.body.style.overflow = 'hidden'
        document.body.style.position = 'fixed'
        document.body.style.top = `-${this.scrollPosition}px`
        document.body.style.width = '100%'
      } else {
        const root = document.documentElement

        if (!root.classList.contains('noscroll')) {
          // html.noscroll is position:fixed, which drops the document scroll offset to 0
          documentScrollPosition = window.pageYOffset
          root.style.top = `-${documentScrollPosition}px`
          root.classList.add('noscroll')
        }
      }
    },
    clearAllBodyScrollLocks () {
      if (this.$device?.isIos) {
        document.body.style.paddingRight = this.bodyPadding
        this.bodyPadding = 0
        document.body.style.removeProperty('overflow')
        document.body.style.removeProperty('position')
        document.body.style.removeProperty('top')
        document.body.style.removeProperty('width')
        window.scrollTo(0, this.scrollPosition)
      } else {
        const root = document.documentElement

        if (root.classList.contains('noscroll')) {
          root.classList.remove('noscroll')
          root.style.removeProperty('top')
          window.scrollTo(0, documentScrollPosition)
        }
      }
    }
  }
}
